import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useHistory } from "react-router-dom";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'greeting-time'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/greeting-time/index.js' implicitly has an 'any' type.
import greetingTime from "greeting-time";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import useService from "../../Hooks/useService";
import VirtualizedAppService from "../../../Services/VirtualizedApp.service";
import MeetingsContainer from "../../Containers/MeetingsContainer";
import RecentUnreadMessagesContainer from "../../Containers/RecentUnreadMessagesContainer";
import WidgetHeader from "../../UI/Widget/WidgetHeader";
import Widget from "../../UI/Widget/Widget";
import CustomCard from "../../UI/CustomCard/CustomCard";
import InstitutionService from "../../../Services/Institution.service";
import useCurrentApiUser from "../../Hooks/useCurrentApiUser";
import VirtualizedAppButton from "../../Presentational/VirtualizedApp/VirtualizedAppButton";
const StartScreen = () => {
    const history = useHistory();
    function changeApp(appName) {
        VirtualizedAppService.getAppHomeUri(appName).then((uri) => {
            history.push(uri);
            history.go(0);
        });
    }
    const currentUser = useCurrentApiUser();
    const [appState, loadApps] = useService(VirtualizedAppService.getAppsForCurrentUser);
    React.useEffect(() => {
        loadApps();
    }, [loadApps]);
    const [imageSource, loadImageSource] = useService(InstitutionService.getStartScreenImage);
    React.useEffect(() => {
        loadImageSource();
    }, [loadImageSource]);
    const [imageLoaded, setImageLoaded] = React.useState(false);
    const greeting = currentUser
        ? `${greetingTime(new Date())}, ${currentUser.firstName}.`
        : `${greetingTime(new Date())}.`;
    return (_jsxs("div", { style: { position: "relative" }, className: "w-100 bg-light fullMinHeightMinusPrimaryNav", children: [_jsx("div", { style: { position: "absolute" }, children: imageSource.data && (_jsx("img", { src: imageSource.data, onLoad: () => {
                        setImageLoaded(true);
                    }, height: 300, style: {
                        objectFit: "cover",
                        width: "100vw",
                        opacity: imageLoaded ? 100 : 0,
                        transition: "opacity 0.5s ease",
                    }, alt: "" })) }), _jsxs("div", { style: { position: "relative", top: 95 }, className: "container", children: [_jsx("div", { children: _jsx(CustomCard, { className: "mb-5", children: _jsx("div", { className: "p-3", children: _jsx("h1", { className: "h3 font-weight-light", children: greeting }) }) }) }), _jsx("div", { className: "row pb-3", children: _jsxs(_Fragment, { children: [_jsxs("div", { className: "col-lg-6", children: [_jsx(MeetingsContainer, {}), _jsx(RecentUnreadMessagesContainer, {})] }), _jsx("div", { className: "col-lg-6", children: _jsxs(Widget, { shadow: true, children: [_jsx(WidgetHeader, { title: "Applications" }), _jsx("div", { className: "card-body pt-0", children: _jsx(ServiceResult, { state: appState, children: (apps) => (_jsx("div", { className: "d-flex w-100", children: apps.map((app, index) => (_jsx(VirtualizedAppButton, { virtualizedApp: app, onClick: () => changeApp(app.name) }, index))) })) }) })] }) })] }) })] })] }));
};
export default StartScreen;
